import React, { Component } from 'react';
import Tela from '../../components/telaInteira/Tela';
import EstruturaI1 from '../../components/EstruturaInicial/EstruturaInicial';
import EstruturaTO1 from '../../components/EstruturaTO1/EstruturaTO1';
import EstruturaTO2 from '../../components/EstruturaTO2/EstruturaTO2';
import EstruturaTO3 from '../../components/EstruturaTO3/EstruturaTO3';
import EstruturaTO4 from '../../components/EstruturaTO4/EstruturaTO4';
import EstruturaTO5 from '../../components/EstruturaTO5/EstruturaTO5';
import EstruturaTO6 from '../../components/EstruturaTO6/EstruturaTO6';
import EstruturaTO7 from '../../components/EstruturaTO7/EstruturaTO7';
import EstruturaTO8 from '../../components/EstruturaTO8/EstruturaTO8';

class Obras extends Component{
    render(){
        return(    
        <div>
            <Tela>
                <EstruturaTO1>
                    <div></div>
                </EstruturaTO1>
                <EstruturaTO2>
                    <div></div>
                </EstruturaTO2>
                <EstruturaTO3>
                    <div></div>
                </EstruturaTO3>
                <EstruturaTO4>
                    <div></div>
                </EstruturaTO4>
                <EstruturaTO5>
                    <div></div>
                </EstruturaTO5>
                <EstruturaTO6>
                    <div></div>
                </EstruturaTO6>
                <EstruturaTO7>
                    <div></div>
                </EstruturaTO7>
                <EstruturaTO8>
                    <div></div>
                </EstruturaTO8>
            </Tela>
        </div>
        )
    }
}

export default Obras;